import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TruncatePipeModule } from '@shared/core/pipes/truncate';

import { LoadersModule } from '@shared/core/components/loaders';
import { HeadersModule } from '@shared/core/components/headers';
import { ButtonsModule } from '@shared/core/components/buttons';
import { AnimatedCounterModule } from '@shared/core/components/animatedCounter';
import { StatsModule } from '@shared/core/components/stats';
import { TagImagesModule } from '@shared/core/components/tagImages';
import { ThumbsModule } from '@shared/core/components/thumbs';

import { TileForProductComponent } from './tile-for-product.shared.component';

@NgModule({
    declarations: [
        TileForProductComponent
    ],
    imports: [
        CommonModule,
        TruncatePipeModule,
        HeadersModule,
        LoadersModule,
        ButtonsModule,
        AnimatedCounterModule,
        StatsModule,
        TagImagesModule,
        ThumbsModule,
    ],
    exports: [
        TileForProductComponent
    ],
    providers: [],
})
export class TileForProductModule { }
